const PORTRAIT =
  "https://customer-assets.emergentagent.com/job_artist-wynn-platform/artifacts/9n5cq1tw_SP068%20copy.jpg";

export default function FounderStory() {
  return (
    <section
      id="founder"
      data-testid="wynn-founder"
      className="relative border-t border-[#F4F1EC]/10 scroll-mt-20"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-12 md:gap-10 items-center">
          <div className="col-span-12 md:col-span-5">
            <div className="relative">
              <div
                aria-hidden
                className="absolute -inset-4 blur-3xl opacity-40 -z-10"
                style={{
                  background:
                    "radial-gradient(50% 50% at 50% 50%, rgba(230,191,255,0.45) 0%, rgba(7,6,8,0) 70%)",
                }}
              />
              <div className="relative aspect-[4/5] overflow-hidden border border-[#F4F1EC]/15">
                <img
                  src={PORTRAIT}
                  alt="Maria-Katharina, maker of WYNN"
                  className="w-full h-full object-cover grayscale-[15%]"
                  draggable="false"
                />
              </div>
            </div>
          </div>

          <div className="col-span-12 md:col-span-6 md:col-start-7">
            <div className="text-[11px] uppercase tracking-[0.32em] text-[#F4F1EC]/55 font-body">
              Made in a quiet room
            </div>
            <h2 className="mt-4 font-display tracking-tight leading-[1.05] text-[clamp(2rem,4.6vw,3.4rem)] font-medium text-[#F4F1EC]">
              I built the companion{" "}
              <span className="italic font-light text-aurora">I needed</span>.
            </h2>
            <div className="mt-7 space-y-5 font-body text-[#F4F1EC]/75 text-[16px] leading-[1.85]">
              <p>
                I&apos;m Maria-Katharina. For years I kept losing the thread to my
                own work — not because the love had left, but because the noise of
                a day kept burying it. I went looking for something small enough to
                carry, gentle enough to trust, and intelligent enough to actually
                meet me where I was.
              </p>
              <p>
                I couldn&apos;t find it, so I started building it by hand. WYNN is
                the result: a pocket-sized studio of affirmations, practices,
                meditations and quiet coaching. The same teal thread that runs
                through the Academy and the podcast — now in your pocket.
              </p>
            </div>
            <p className="mt-8 font-display text-[24px] md:text-[28px] italic font-light leading-[1.4] text-[#F4F1EC]">
              &ldquo;Not more effort. Just a shift. That&apos;s the whole thing.&rdquo;
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
